import React from "react";
import styled from "styled-components";
import classnames from 'classnames';
import { ReactComponent as Plus } from "./../../atoms/icons/plus.svg";
import { ReactComponent as Minus } from "./../../atoms/icons/minus.svg";

const Wrap = styled.div`
    width: 120px;
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: flex-end;
    margin: 0 auto;

    input {
        cursor: default;
    }

    &.sold input.cnt-input {
        opacity: 0.3;
    }

    &.excluded {
        opacity: 0.3;
    }
`;

const PlusButton = styled.button`
    width: 33px;
    height: 32px;
    border: none;
    background: none;
    padding: 0;
    outline: none;
    cursor: pointer;
    user-select: none;
    outline: none;
    box-shadow: none;

    &:focus,
    &:hover,
    &:active {
        outline: none;
        box-shadow: none;
    }

    &:disabled {
        opacity: 0.3;
        cursor: default;
    }

    svg rect {
        fill: transparent;
    }

    &:not(:disabled):hover svg rect,
    &:not(:disabled):active svg rect {
        fill: var(--color-secondary);
    }

    &:not(:disabled):hover svg path,
    &:not(:disabled):active svg path {
        fill: #fff;
    }
`;

const MinusButton = styled.button`
    height: 32px;
    border: none;
    background: none;
    padding: 0;
    outline: none;
    cursor: pointer;
    outline: none;
    box-shadow: none;

    &:focus,
    &:hover,
    &:active {
        outline: none;
        box-shadow: none;
    }

    &:disabled {
        opacity: 0.3;
        cursor: default;
    }

    svg rect {
        fill: transparent;
    }

    &:not(:disabled):hover svg rect,
    &:not(:disabled):active svg rect {
        fill: #e02020;
    }

    &:not(:disabled):hover svg path,
    &:not(:disabled):active svg path {
        fill: #fff;
    }
`;

const Input = styled.input`
    width: 32px;
    margin: 0 8px;
    padding: 0 2px;
    border: none;
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    color: var(--color-heading);
    letter-spacing: -0.6px;
    text-align: center;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: transparent;

    &:focus {
        border: none;
        box-shadow: none;
        outline: none;
    }
`;

function Controls(props) {
    const { quantitySelected, excluded, refData, isSold } = props;

    const increment = () => {
        if (props.excluded) return;
        let quantity = parseInt(props.quantitySelected);
        if (quantity <= 29) handleQuantityChange(quantity + 1);
    };
    const decrement = () => {
        if (props.excluded) return;
        let quantity = parseInt(props.quantitySelected);
        handleQuantityChange(
            quantity - 1 < 0 ? 0 : quantity - 1
        );
    };
    const handleChange = (event) => {
        handleQuantityChange(
            event.target.value < 0 ? 0 : event.target.value
        );
    };

    const handleQuantityChange = (quantity) => {
        props.quantityChange(quantity);
    };

    const disabledMinusCheck = () => {
        return quantitySelected === 0 || excluded ? true : false;
    }
    const disabledPlusCheck = () => {
        return excluded || isSold;
    }

    const disabledMinusStatus = disabledMinusCheck();
    const disabledPlusStatus = disabledPlusCheck();

    return (
        <Wrap
            className={classnames('meal-item', { 'excluded': excluded }, { 'sold': isSold })}
        >
            <MinusButton
                onClick={decrement}
                disabled={disabledMinusStatus}
            >
                <Minus />
            </MinusButton>
            <Input
                value={quantitySelected}
                readOnly
                onChange={handleChange}
                className="cnt-input"
                ref={typeof refData !== "undefined" ? refData : null}
            />
            <PlusButton onClick={increment} disabled={disabledPlusStatus}>
                <Plus />
            </PlusButton>
        </Wrap>
    );

}

export default Controls;
